import { create, v, w } from '@dojo/framework/core/vdom';
import { ResourceParser } from './resource-parser';
import { createNlsMiddleware } from 'lcc-state';

export interface resourceDitabookSelectorProperties {
	topic: string;
	key?: string;
	xqa?: string;
	classes?: any;
	formatting?: {
		[key: string]: string;
	};
}

const nls = createNlsMiddleware('ditabook');
const resources = createNlsMiddleware('resources');

const factory = create({
	nls,
	resources
}).properties<resourceDitabookSelectorProperties>();

export const resourceDitabookSelector = factory(({ properties, middleware: { nls, resources } }) => {
	const { topic, key, xqa, classes, formatting } = properties();
	const { messages: resourcesMessages } = resources();
	const { messages: ditabookMessages, format } = nls();
	const inResources = topic in resourcesMessages;
	const inDitabook = topic in ditabookMessages;

	return inResources
		? v(
				'div',
				{
					key,
					xqa,
					classes
				},
				[
					w(ResourceParser, {
						messages: resourcesMessages,
						topicid: topic,
						formatting: formatting
					})
				]
		  )
		: inDitabook
		? v('div', {
				key,
				xqa,
				classes,
				innerHTML: formatting ? format(topic, formatting) : ditabookMessages[topic]
		  })
		: null;
});

export default resourceDitabookSelector;
